/**
 * Type definitions for Feedback Forms
 * Centralizes all TypeScript interfaces and types
 */

export enum QuestionType {
  NPS = 1,
  RATING = 2,
  FREE_TEXT = 3,
}

export enum FormStatus {
  DRAFT = 1,
  SUBMITTED = 2,
  COMPLETED = 3,
}

export interface Scale {
  min: number;
  max: number;
  minText?: string;
  maxText?: string;
  translations?: ScaleTranslation[];
}

export interface ScaleTranslation {
  languageId: number;
  minText?: string;
  maxText?: string;
}

export interface QuestionText {
  languageId: number;
  text: string;
}

export interface Question {
  id: string;
  typeId: QuestionType;
  text: QuestionText[];
  visible?: boolean;
  required?: boolean;
  scale?: Scale;
  questionText?: string;
  title?: string;
}

export interface FormTranslation {
  languageId: number;
  name: string;
  header: string;
  introText: string;
}

export interface FormJson {
  id: string;
  baseLanguageId: number;
  translations: FormTranslation[];
  questions: Question[];
}

export interface FormData {
  formJson: FormJson;
  languageId: number;
  metaData: MetaData;
  isSubmitted: boolean;
}

export interface MetaData {
  companyName: string;
  companyLogo: string;
  sender: {
    address: string;
    displayName: string;
  };
  recipient: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  jobTitle: string;
}

export interface QuestionResponse {
  questionId: string;
  questionText: string;
  type: string;
  answer: string | number;
  scale?: Scale;
}

export interface FormResponse {
  formId: string;
  responseLanguage: string;
  response: QuestionResponse[];
}

export interface FormSubmissionPayload {
  id: string;
  formId: string;
  tenantId: string;
  rawJson: string;
  feedbackLanguage: string;
}

export interface GetFormByResponseParams {
  responseId: string;
  tenantId: string;
  language: string;
}

export interface LanguageOption {
  id: number;
  label: string;
}

export interface ValidationErrors {
  [questionId: string]: string;
}

export interface QuestionResponses {
  [questionId: string]: string | number;
}
